module.exports = __webpack_public_path__ + "static/media/domek.cab960ac.jpg";